export default {
  pages: {
    key: "title",
    data: [
      {title: "Analytics Dashboard",        url: "/dashboard/analytics",                icon: "HomeIcon",           is_bookmarked: false},
    ]
  }
   
}
